import React, { Component } from 'react'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'
import Slide from '@mui/material/Slide'

// Components
import HeadGlobal from './headerGlobal'
// Utils
import {
  welcomeEs,
  welcomeFr,
  welcomeEn,
  welcomePtg,
} from '../textApp/textTrad'
import upImg from '../assets/images/levelup.gif'
import { navigationGA } from '../data/GA'

class LevelUp extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.selectLang = this.selectLang.bind(this)
  }

  selectLang = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return welcomeEs
      case 'fr':
        return welcomeFr
      case 'en':
        return welcomeEn
      case 'pt':
        return welcomePtg
      default:
        return welcomeEn
    }
  }
  continue = () => {
    this.props.handleNext(3)
  }
  render() {
    const txt = this.selectLang()
    const { setlang, purcent } = this.props
    navigationGA('Half Survey', 'levelup', 'levelup')
    return (
      <div className='center'>
        <div className='main'>
          <CssBaseline>
            <HeadGlobal setlang={setlang} changeLang={true} />
          </CssBaseline>
          <Typography
            component='h1'
            variant='h4'
            align='center'
            sx={{
              fontWeight: '600',
              paddingBottom: '1vh',
              fontSize: {
                xs: '1rem',
                sm: '1.5rem',
                md: '1.5rem',
              },
            }}
          >
            {txt.levelUp}
          </Typography>
          <Slide
            direction='right'
            in={true}
            mountOnEnter
            unmountOnExit
            timeout={700}
          >
            <Container
              sx={{
                // height: '50vh',
                width: {
                  xs: '90vw',
                  sm: '85vw',
                  md: '50vw',
                },
                display: 'grid',
              }}
            ></Container>
          </Slide>
          <img className='up' src={upImg} alt='' />
          <Slide
            direction='down'
            in={true}
            mountOnEnter
            unmountOnExit
            timeout={700}
          >
            <Button
              onClick={this.continue}
              variant='contained'
              sx={{
                marginTop: '2vh',
                padding: {
                  xs: '1rem 4rem',
                  sm: '1rem 2rem',
                  md: '0.5rem 2rem',
                },
                fontSize: {
                  xs: '1.2rem',
                  sm: '1.3rem',
                  md: '1.3rem',
                },
              }}
            >
              {txt.cont}
            </Button>
          </Slide>
          <div className='prgrs'>
            <div className='brdrPrgrs'></div>
            <div className='prgsBr' style={{ width: `${purcent}%` }}>
              {purcent}%
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LevelUp
